export default __webpack_public_path__ + "static/media/Nectar_Hospitality_capture.3b8fd8c3.JPG";